
export default function About() {
  return (
    <section id="about" className="bg-[#F5F7FA] py-16 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4 sm:mb-6">
              <div className="w-2 h-2 rounded-full bg-[#0B1F3A]"></div>
              <span
                className="text-[#0B1F3A] text-xs font-semibold tracking-widest uppercase"
                style={{ fontFamily: "Open Sans, sans-serif" }}
              >
                About Us
              </span>
            </div>
            <h2
              className="text-[#0B1F3A] text-2xl sm:text-3xl lg:text-4xl leading-relaxed mb-6 sm:mb-8"
              style={{
                fontFamily: "Playfair Display, serif",
                lineHeight: "1.6",
              }}
            >
              We believe quality renovations should be within reach. Premier Renovations brings years of hands-on experience to every kitchen and bathroom project, delivering work that lasts without the premium price tag.
            </h2>
            <p
              className="text-[#1A1A1A] text-base sm:text-lg leading-relaxed mb-6"
              style={{
                fontFamily: "Open Sans, sans-serif",
                lineHeight: "1.7",
              }}
            >
              Whether you're looking for a full kitchen upgrade, custom tile work, onyx showers, or walk-in tubs, we handle it all with the same level of care. No shortcuts, no surprises—just honest work at a fair price.
            </p>
            <div className="flex items-center gap-2 mt-6 sm:mt-8">
              <span
                className="text-[#0B1F3A] font-bold text-base sm:text-lg"
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                Premier Renovations
              </span>
              <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center">
                <i className="ri-check-line text-white text-sm"></i>
              </div>
            </div>
          </div>

          {/* Right Images */}
          <div className="lg:col-span-3">
            <div className="flex flex-col gap-4">
              <div className="w-full h-48 sm:h-64 rounded-3xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/70d6cfa394f6ae4adc669a69972331d9.jpg"
                  alt="Onyx Shower Installation"
                  className="w-full h-full object-cover object-center"
                  onError={(e) => {
                    // Fallback image if the remote source fails
                    e.currentTarget.src =
                      "https://via.placeholder.com/800x400?text=Onyx+Shower";
                  }}
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="w-full h-40 sm:h-64 rounded-3xl overflow-hidden shadow-lg">
                  <img
                    src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/43e94e3ab266063b14c7c6b068374a34.png"
                    alt="Walk-In Tub"
                    className="w-full h-full object-cover object-center"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://via.placeholder.com/400x400?text=Walk-In+Tub";
                    }}
                  />
                </div>
                <div className="w-full h-40 sm:h-64 rounded-3xl overflow-hidden shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=custom%20kitchen%20renovation%20with%20white%20shaker%20cabinets%2C%20quartz%20countertops%2C%20subway%20tile%20backsplash%2C%20stainless%20appliances%2C%20modern%20pendant%20lights%2C%20hardwood%20floors%2C%20professional%20remodeling%20work%2C%20bright%20and%20spacious%20design&width=400&height=400&seq=about-kitchen-001&orientation=squarish"
                    alt="Kitchen Renovation"
                    className="w-full h-full object-cover object-center"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://via.placeholder.com/400x400?text=Kitchen+Renovation";
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
